<template>
    <div>
        <div class="row no-gutters justify-content-start align-items-center common-step-head">
            <img
                src="../assets/images/step_icon.png"
                alt="step"
            />
            <p>{{$t('stepTwo.title')}}</p>
        </div>
        <div class="progress custom-progress">
            <div
                class="progress-bar"
                role="progressbar"
                style="width: 50%"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
        </div>
        <div class="row justify-content-between no-gutters common-step-padding">
            <!-- 商品信息 begin -->
            <div class="col-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <div class="goods-info">
                    <img
                        :src="$store.state.giftImage"
                        :alt="$store.state.giftName"
                    />
                    <div class="good-info-mask step-good-mask good-mask-one-row">
                        <span>{{$store.state.giftName}}</span>
                    </div>
                </div>
            </div>
            <!-- 商品信息 end -->
            <div class="col-12 col-sm-12 col-md-7 col-lg-8 col-xl-8">
                <div class="left-form-distance common-form-margin">
                    <!-- 评分 begin -->
                    <div class="form-group custom-input">
                        <label>1. {{$t('stepTwo.despOne')}}</label>
                        <div class="rating-block">
                            <span
                                v-for="(item,index) in stars"
                                v-bind:key="index"
                            >
                                <img
                                    src="../assets/images/on_icon.svg"
                                    v-if="item.active"
                                    @click="rating(index)"
                                    alt="rating_icon"
                                />
                                <img
                                    src="../assets/images/off_icon.svg"
                                    v-else
                                    @click="rating(index)"
                                    alt="rating_icon"
                                    class="off_img"
                                />
                            </span>
                        </div>
                    </div>
                    <!-- 评分 end -->
                    <!-- 产品评论 begin-->
                    <form action="">
                        <div class="form-group custom-input">
                            <label>2. {{$t('stepTwo.despTwo')}}</label>
                            <p class="small-notice">{{$t('stepTwo.notice')}}</p>
                            <textarea
                                :class="showCommentError||showCommentError0?'error-border':''"
                                rows="3"
                                minlength="10"
                                v-model="$store.state.stepTwo.commentValue"
                                :placeholder="$t('stepTwo.commentPlaceholder')"
                                @focus="onFocusComment()"
                                @input="onInputComment()"
                            ></textarea>
                            <span
                                class="error-font"
                                v-if="showCommentError0&&!showCommentError"
                            >{{$t('stepTwo.commentErrMsg')}}</span>
                            <span
                                class="error-font"
                                v-if="showCommentError&&!showCommentError0"
                            >{{$t('stepTwo.notice')}}</span>

                        </div>
                        <div class="row no-gutters justify-content-around step-btn-group">
                            <button
                                type="button"
                                class="common-comfirm-btn common-prev-btn"
                                @click="prevStep()"
                            >
                                {{$t('stepTwo.btnPrev')}}
                            </button>
                            <button
                                type="button"
                                class="common-comfirm-btn"
                                @click="nextStep()"
                                :disabled="$store.state.stepTwo.isDisabledBtnNext"
                            >
                                {{$t('stepTwo.btnNext')}}
                            </button>
                        </div>
                    </form>
                    <!-- 产品评论 end-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Address',
    data() {
        return {
            showCommentError: false, // 评论字数不足10 错误提示
            showCommentError0: false, // 评论字数超过20000 错误提示
            stars: [{ // 星星点亮状态
                active: false
            },
            {
                active: false
            },
            {
                active: false
            },
            {
                active: false
            },
            {
                active: false
            }],
        }

    },
    components: {

    },
    methods: {
        // 评分
        rating(index) {
            let total = this.stars.length //星星总数
            let idx = index + 1 //这代表选的第idx颗星-也代表应该显示的星星数量
            let starNum = this.$store.state.stepTwo.starNum
            //进入if说明页面为初始状态
            if (starNum === 0) {
                this.$store.state.stepTwo.starNum = idx
                for (let i = 0; i < idx; i++) {
                    this.$set(this.stars[i], 'active', true)
                }
            } else {
                //如果再次点击当前选中的星级-仅取消掉当前星级，保留之前的。
                if (idx === starNum) {
                    for (let i = 0; i < starNum; i++) {
                        this.$set(this.stars[i], 'active', false)
                    }
                }
                //如果小于当前最高星级，则直接保留当前星级
                if (idx < starNum) {
                    for (let i = idx; i < starNum; i++) {
                        this.$set(this.stars[i], 'active', false)
                    }
                }
                //如果大于当前星级，则直接选到该星级
                if (idx > starNum) {
                    for (var i = 0; i < idx; i++) {
                        this.$set(this.stars[i], 'active', true)
                    }
                }
                let count = 0 //计数器-统计当前有几颗星
                for (let i = 0; i < total; i++) {
                    if (this.stars[i].active) {
                        count++
                    }
                }
                this.$store.state.stepTwo.starNum = count
            }
            this.updateBtnStatus()
        },
        // 评论聚焦事件
        onFocusComment() {
            this.showCommentError = false
        },
        // 监听评论输入事件，更新下一步按钮状态
        onInputComment() {
            this.updateBtnStatus()
        },
        // 返回上一步
        prevStep() {
            this.$router.push({ path: '/stepOne' })
            // this.$router.go(-1)
        },
        // 跳转步骤三  如果评分低于四星 直接跳转到填写地址页面
        nextStep() {
            let starNum = this.$store.state.stepTwo.starNum
            let commentValue = this.$store.state.stepTwo.commentValue

            if (starNum < 4) {
                this.$router.push({ path: '/address' })
            } else {
                this.$router.push({ path: '/stepThree' })
            }
        },
        // 更新下一步按钮状态
        updateBtnStatus() {
            let starNum = this.$store.state.stepTwo.starNum
            let commentValue = this.$store.state.stepTwo.commentValue
            let isDisabledBtnNext = true
            if (starNum && commentValue.length >= 10 && commentValue.length <= 20000) {
                this.showCommentError = false
                this.showCommentError0 = false
                isDisabledBtnNext = false
            } else if (starNum && commentValue.length > 20000) { 
                this.showCommentError0 = true
                this.showCommentError = false
                isDisabledBtnNext = true
            } else {
                isDisabledBtnNext = true
            }

            this.$store.state.stepTwo.isDisabledBtnNext = isDisabledBtnNext
        },

    },
    mounted() {
        let starNum = this.$store.state.stepTwo.starNum
        for (let i = 0; i < starNum; i++) {
            this.$set(this.stars[i], 'active', true)
        }
    }
}
</script>

<style lang="scss" scoped>
.rating-block span {
    display: inline-block;
    width: 35px;
    height: 35px;
    margin-right: 20px;
    cursor: pointer;
}

.custom-input label {
    font-weight: bold;
}

.small-notice {
    margin-bottom: 15px;
    color: #a1a1a6;
    padding-left: 10px;
}
</style>